// extracted by mini-css-extract-plugin
module.exports = {"componentWrapper":"hospitalizations_componentWrapper__1pYkh"};